import { CustomAccommodation } from "../objects/customAccommodation";
import { SourceElementData } from "../objects/sourceElementData";
import { FilterSortItem } from "../pageBuilderSourceFilterSortModal";

export class CustomAccommodationsSourceData implements SourceElementData {
    constructor(
        private locale: number,
        private accommodation: CustomAccommodation
    ) { }

    public getFieldValue(field: string): string | null {
        switch (field) {
            case 'id': return this.accommodation.id.toString();
            case 'name': return this.accommodation.name ?? '';
        }
        return null;
    }

    public getFiterSortItem(): FilterSortItem {
        return {
            id: this.getFieldValue('id') ?? '',
            label: this.getFieldValue('name') ?? '',
            active: true
        };
    }
}